var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductLinePrinting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#43BC9B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.8,13V4c0-1-0.8-1.7-1.8-1.8H4C3,2.3,2.3,3,2.3,4v9c0,1,0.8,1.7,1.8,1.8h9C14,14.7,14.7,14,14.8,13z  M7.5,12.2h-2c-0.4,0-0.7-0.3-0.8-0.8v-2c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v1.3h1.3c0.4,0,0.8,0.3,0.8,0.8S7.9,12.2,7.5,12.2 z M7.5,6.2H6.3v1.3c0,0.4-0.3,0.8-0.8,0.8S4.8,7.9,4.8,7.5v-2c0-0.4,0.3-0.7,0.8-0.8h2c0.4,0,0.8,0.3,0.8,0.8S7.9,6.2,7.5,6.2z  M12.3,11.5c0,0.4-0.3,0.7-0.8,0.8h-2c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h1.3V9.5c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8 V11.5z M12.3,7.5c0,0.4-0.3,0.8-0.8,0.8s-0.8-0.3-0.8-0.8V6.2H9.5c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h2 c0.4,0,0.7,0.3,0.8,0.8V7.5z M16.5,18.2h-9c-1,0-1.7-0.8-1.8-1.8v-0.3H13c1.8,0,3.2-1.5,3.3-3.2V5.7h0.3c1,0,1.7,0.8,1.8,1.8v9 C18.2,17.5,17.5,18.2,16.5,18.2z M21.8,11v9c0,1-0.8,1.7-1.8,1.8h-9c-1,0-1.7-0.8-1.8-1.8v-0.3h7.3c1.8,0,3.2-1.5,3.3-3.3V9.2H20 C21,9.3,21.7,10,21.8,11z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLinePrinting);
export default __webpack_public_path__ + "static/media/product_line_printing.ea3cfb1e0d64c486fdf1823b7686693b.svg";
export { ForwardRef as ReactComponent };